export default "__VITE_ASSET__MABh1vsx__"